import { render, staticRenderFns } from "./GridWithSidebar.vue?vue&type=template&id=4f9462f4&"
import script from "./GridWithSidebar.vue?vue&type=script&lang=js&"
export * from "./GridWithSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports